module.exports = __webpack_public_path__ + "static/safe-3efbccd0f9231b1dd931f8f595892715.jpg";